import React from 'react'
import { ModelValueFilter, StaticFilter } from '@morningtrain/react-filters'
import { Collection, ForEachModel, Prefix, PrefixIndex, ValueToModel } from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import { Text } from 'ui'
import PerformanceIndicatorFields from 'pages/app/settings/departments/partials/PerformanceIndicatorFields'

export default function PerformanceIndicatorEditor ({ year }) {
  return (
    <div>
      <Text weight='semibold'>
        {year}
      </Text>
      <Collection resourceName='performance_indicators' operationName='by_month' operationContext={{ year: year }}>
        <ModelValueFilter name='department' modelKey='id' />
        <StaticFilter name='year' value={year} />
        <StaticFilter name='type' value='wage_ratio' />
        <div className='flex space-x-3'>
          <ForEachModel>
            <div className='w-1/12'>
              <Displays.Text name='key' />
              <ValueToModel name='model'>
                <Prefix name='performance_indicators'>
                  <PrefixIndex>
                    <PerformanceIndicatorFields year={year} />
                  </PrefixIndex>
                </Prefix>
              </ValueToModel>
            </div>
          </ForEachModel>
        </div>
      </Collection>
    </div>
  )
}
